import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import * as archiveFolderApi from "../../api/archiveApi/archiveFolderApi";
import SubTitle from "../../components/SubTitle";
import {useGetItemQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {KPFolder, initializeFolder} from "../../models/serverModels/archive/KPFolder";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import FolderForm from "./FolderForm";

const UpdateFolder = () => {
  const {id} = useParams();
  const {state} = useLocation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: archiveList, isLoading: isGetLoading} = useGetItemQuery<ResponseItem<KPFolder>>({
    key: ["ArchiveList", id],
    api: () => archiveFolderApi.getItem({id: parseInt(id!), token: tokenState}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<KPFolder>,
    Params.Update<KPFolder>
  >({
    api: archiveFolderApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate(`/Archive/${archiveList?.item?.folderUID}`);
        queryClient.invalidateQueries("ArchiveList");
      },
    },
  });

  const methods = useForm<KPFolder>({
    defaultValues: archiveList?.item || initializeFolder(),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(archiveList?.item);
  }, [archiveList?.item, reset]);

  const onSubmit: SubmitHandler<KPFolder> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeFolder(), ...data, folderUID: state},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="폴더 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <FolderForm captionColor="#546E7A" />
            <ConfirmButtonGroup
              link={`/Archive/${archiveList?.item?.folderUID}`}
              cancelText="취소"
              confirmText="수정"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateFolder;
